import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import {
  ProgramReport,
  roundToTwoDecimals,
  useBackendProgramReport
} from "./reportUtils";
import { Alert, CircularProgress, Typography } from "@mui/material";
import { format } from "date-fns";
import { useEffect, useState } from "react";

interface BackendProgramReportProps {
  institutionId?: string;
  columns: GridColDef<ProgramReport>[];
}

export const BackendProgramReport = ({
  institutionId,
  columns
}: BackendProgramReportProps) => {
  const {
    report: backendReport,
    status: fetchReportStatus,
    error: fetchReportError,
    generatedDate
  } = useBackendProgramReport();
  const [report, setReport] = useState<ProgramReport[]>([]);

  const prepareReport = (institutionId: string) => {
    const institutionReport: ProgramReport[] = [];
    for (const item of backendReport) {
      if (item.institution_id === institutionId && item.program_id) {
        const reportItem: ProgramReport = {
          averageCompletedPerTrainee: roundToTwoDecimals(
            parseFloat(item.assessments_per_trainee || "0.0")
          ),
          id: `${item.institution_id}-${item.program_id}`,
          institutionId: item.institution_id,
          institutionName: item.institution_name || "N/A",
          assignedAssessmentEvents: parseInt(item.n_assigned || "0"),
          attendingsInProgram: parseInt(item.n_attending || "0"),
          completedAssessmentEvents: parseInt(item.n_complete || "0"),
          createdAssessmentEvents: parseInt(item.n_created || "0"),
          traineesInProgram: parseInt(item.n_trainee || "0"),
          percentCompleted: roundToTwoDecimals(
            parseFloat(item.pct_complete || "0.0") * 100
          ),
          programId: item.program_id,
          programName: item.program_name || "N/A"
        };
        institutionReport.push(reportItem);
      }
    }
    setReport(institutionReport);
  };

  useEffect(() => {
    if (institutionId) {
      prepareReport(institutionId);
    }
  }, [institutionId]);

  if (fetchReportStatus === "idle") {
    return <div>Awaiting Data...</div>;
  }

  if (fetchReportStatus === "loading") {
    return <CircularProgress />;
  }

  if (fetchReportStatus === "failed") {
    return <Alert severity="error">{fetchReportError}</Alert>;
  }

  return (
    <>
      <div>
        {generatedDate && (
          <Typography>
            {`Data generated: ${format(generatedDate, `PPPPpppp`)}
      `}
          </Typography>
        )}
      </div>

      <DataGrid
        aria-label="reports-table"
        rows={report}
        columns={columns}
        getRowId={(row) => row.programId}
        slots={{ toolbar: GridToolbar }}
      />
    </>
  );
};
